<ebw-monorepo-sidebar-header
  [icon]="'stacks'"
  [title]="'map.sidebar.ebw_layers_configurator.title'"
  [isSvg]="false"
  [isOutline]="true"
>
  {{ 'map.sidebar.ebw_layers_configurator.info_section' | translate }}
</ebw-monorepo-sidebar-header>
<div class="scrollable-div">
  <mat-tab-group
    [selectedIndex]="formSelectedTab.value"
    (selectedIndexChange)="formSelectedTab.setValue($event)"
    animationDuration="0ms"
  >
    <mat-tab [label]="tab.tabName" *ngFor="let tab of visibleTabs; let tab_i = index">
      <div class="layers">
        <div [formGroup]="forms[tab_i]" ng-scrollbars>
          <div *ngFor="let content of tab.content">
            <div class="section">

              <span *ngIf="content.groupName.length > 0"><br /></span>
              <span class="title" [innerHtml]="content.groupName"></span>

              <ng-container *ngFor="let value of content.values; let element_index = index">
                <!-- normale -->
                <div *ngIf="!value.children" class="slide-toggle-wrapper row g-0">
                  <div class="col-9">
                    <mat-slide-toggle
                      id="{{ value }}"
                      color="accent"
                      [formControl]="getControls(tab_i, content.groupName)[element_index]"
                      [disabled]="isLayerActive(value)"
                    >
                      {{ content.labels[element_index] }}
                    </mat-slide-toggle>
                  </div>
                  <div class="col-3">
                    <div class="row">
                      <div class="col-6">
                        <button
                          *ngIf="content.legend"
                          mat-icon-button
                          color="primary"
                          class="ml-auto center-horizontally"
                          (click)="openDialog(content.labels[element_index], content.legend[element_index])"
                        >
                          <mat-icon>open_in_new</mat-icon>
                        </button>
                      </div>
                      <div class="col-6" (click)="$event.stopPropagation()">
                        <button mat-icon-button [matMenuTriggerFor]="menu" class="ml-auto center-horizontally">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu" class="menu-panel" (click)="$event.stopPropagation()">

                          <button
                            mat-menu-item class="w-100"
                            *ngIf="content.styles && content.styles[element_index]"
                            (click)="openDialogLegend(content.styles[element_index], content.labels[element_index])"
                          >
                            <mat-icon class="me-1">legend_toggle</mat-icon>
                            <span>{{ 'map.sidebar.ebw_layers_configurator.legend' | translate }}</span>
                          </button>

                          <ebw-monorepo-opacity-slider [layerId]="value"></ebw-monorepo-opacity-slider>
                        </mat-menu>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- con sotto-figli -->
                <div *ngIf="value.children" class="slide-toggle-wrapper-father">
                  <mat-accordion>
                    <mat-expansion-panel style="box-shadow: none;" [expanded]="isExpanded(element_index)">
                      <mat-expansion-panel-header>
                        <div class="col-9">
                          <mat-checkbox
                            color="accent"
                            [checked]="isParentChecked(getControls(tab_i, content.groupName)[element_index])"
                            [indeterminate]="isParentIndeterminate(getControls(tab_i, content.groupName)[element_index])"
                            (click)="$event.stopPropagation(); enableOrDisableChildren(tab_i, content.groupName, element_index)"
                          >
                            {{ content.labels[element_index].name }}
                          </mat-checkbox>
                        </div>
                      </mat-expansion-panel-header>

                      <mat-panel-description class="d-flex flex-column">
                        <div *ngFor="let subValue of value.children; let j = index" class="slide-toggle-wrapper">
                          <div class="col-10 offset-1">
                            <mat-slide-toggle [formControl]="getChildrenControl(tab_i, content.groupName, element_index, j)">
                              {{ content.labels[element_index].children[j] }}
                            </mat-slide-toggle>
                          </div>
                          <div class="col-1">
                            <div (click)="$event.stopPropagation()">
                              <button mat-icon-button [matMenuTriggerFor]="menu" class="ml-auto center-horizontally">
                                <mat-icon>more_vert</mat-icon>
                              </button>
                              <mat-menu #menu="matMenu" class="menu-panel" (click)="$event.stopPropagation()">
      
                                <button
                                  mat-menu-item class="w-100"
                                  *ngIf="content.styles && content.styles[element_index] && content.styles[element_index].children[j]"
                                  (click)="openDialogLegend(content.styles[element_index].children[j], content.labels[element_index].children[j])"
                                >
                                  <mat-icon class="me-1">legend_toggle</mat-icon>
                                  <span>{{ 'map.sidebar.ebw_layers_configurator.legend' | translate }}</span>
                                </button>
      
                                <ebw-monorepo-opacity-slider [layerId]="subValue"></ebw-monorepo-opacity-slider>
                              </mat-menu>
                            </div>
                          </div>
                        </div>
                      </mat-panel-description>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
